export const GLOBAL_NAMESPACE = 'tncet_bim.';
export const AUTHORIZATION = GLOBAL_NAMESPACE + 'authorization';
export const REMEMBER_USERNAME = GLOBAL_NAMESPACE + 'username';
export const REMEMBER_PASSWORD = GLOBAL_NAMESPACE + 'password';
export const REMEMBER_TAG = GLOBAL_NAMESPACE + 'remember';

export const MODEL_UUID = GLOBAL_NAMESPACE + 'model_uuid';
export const PROJECT_UUID = GLOBAL_NAMESPACE + 'project_uuid';
export const PROJECT_NAME = GLOBAL_NAMESPACE + 'project_name';
export const USER_UUID = GLOBAL_NAMESPACE + 'user_uuid';
export const ACTIVE_MODEL_UUID = GLOBAL_NAMESPACE + "ACTIVE_MODEL_UUID"
export const ACTIVE_MODEL_NAME = GLOBAL_NAMESPACE + "ACTIVE_MODEL_NAME"
export const SHOW_MODEL_UUIDS = GLOBAL_NAMESPACE + "SHOW_MODEL_UUIDS"

class LocalStore {

    public get(key: string) {
        return JSON.parse(localStorage.getItem(key) || 'null') || null;
    }

    public set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    get token(): string {
        return this.get(AUTHORIZATION) || '';
    }

    set token(value: string) {
        this.set(AUTHORIZATION, value);
    }

    get password(): string {
        return this.get(REMEMBER_PASSWORD) || '';
    }
    set password(value: string) {
        this.set(REMEMBER_PASSWORD, value);
    }

    get projectUuid(): string {
        return this.get(PROJECT_UUID) || '';
    }

    set projectUuid(value: string) {
        this.set(PROJECT_UUID, value);
    }

    get userUuid(): string {
        return this.get(USER_UUID) || '';
    }
    set userUuid(value: string) {
        this.set(USER_UUID, value);
    }

    public setProjectName(value: string) {
        if (value == null) {
            this.remove(PROJECT_NAME);
            return;
        }
        this.set(PROJECT_NAME, value);
    }

    public getProjectName() {
        return this.get(PROJECT_NAME);
    }

    get modelUuid(): string {
        return this.get(MODEL_UUID) || '';
    }
    set modelUuid(value: string) {
        this.set(MODEL_UUID, value);
    }

    get activeModelUuid(): string {
        return this.get(ACTIVE_MODEL_UUID) || '';
    }

    set activeModelUuid(value) {
        this.set(ACTIVE_MODEL_UUID, value)
    }

    get activeModelName(): string {
        return this.get(ACTIVE_MODEL_NAME) || '';
    }

    set activeModelName(value) {
        this.set(ACTIVE_MODEL_NAME, value)
    }

    set showModelUuidList(value: string[]) {
        this.set(SHOW_MODEL_UUIDS, value)
    }

    get showModelUuidList(): string[] {
        return this.get(SHOW_MODEL_UUIDS) || []
    }



    clearProjectInfo() {
        this.remove(PROJECT_UUID);
        this.remove(ACTIVE_MODEL_UUID);
        this.remove(ACTIVE_MODEL_NAME);
        this.remove(SHOW_MODEL_UUIDS);
        this.remove(MODEL_UUID);
    }

    clear() {
        this.remove(AUTHORIZATION);
        this.remove(PROJECT_UUID);
        this.remove(USER_UUID);
        this.remove(ACTIVE_MODEL_UUID);
        this.remove(ACTIVE_MODEL_NAME);
        this.remove(SHOW_MODEL_UUIDS);
        this.remove(MODEL_UUID);
    }
}

export default new LocalStore();